<template>
  <!-- CARDS -->
  <div class="col-grid-12 no-padding">
    <div class="row" :class="parentClass">
      <card v-if="index < numberOfCardsInRow" v-for="(card, index) in cards.items"
        :key="index"
        :card="card"
        :numberOfCardsInRow="numberOfCardsInRow"
        :index="index+1"
        :hoverNo="hoverNo"
        :setHoverNo="setHoverNo"
        :setParentClass="setParentClass"
        :boxHover="boxHover"
        :boxOut="boxOut"
        :cardType="cardType"
      />
    </div>
  </div>

</template>

<script>
import CardRowMixin from 'mixins/CardRowMixin'
import Card from './Card'
import { mapState } from 'vuex'

export default {
  name: 'CardsRow',
  components: {
    Card
  },
  mixins: [
    CardRowMixin
  ],
  data: function () {
    return {
      parentClass: '',
      hoverNo: -1,
      numberOfCardsInRow: 6
    }
  },
  props: {
    cards: Object,
    cardType: String
  },
  computed: {
    ...mapState({
      userActive: state => state.general.userActive,
      touchDevice: state => state.general.touchDevice
    })
  },
  methods: {
    boxHover: function (no) {
      // console.log('hover', no)
      this.hoverIndex = no
      this.setHoverNo(this.hoverIndex)
    },
    boxOut: function () {
      this.hoverIndex = -1
      this.setHoverNo(this.hoverIndex)
    }
  },
  watch: {
    hoverNo: function (hoverNo) {
      // console.log('row watch') // TODO delete
      if (hoverNo === -1) {
        this.setParentClass('')
      } else if (hoverNo === 1) {
        this.setParentClass('hover-first')
      } else if (hoverNo === this.numberOfCardsInRow) {
        this.setParentClass('hover-last')
      } else {
        this.setParentClass('hover-middle')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "uc/_variables";
@import 'uc/_mixins';

    .row {
        // margin-bottom: 30px;
        @include cf;
    }

    // Hover animations
    /deep/ {
        .card {
            transition: transform 0.3s ease;
            transform: translate3d(0,0,0);
        }
        &.hover-first {
            .card {
              transform: translate3d(20%,0,0);
            }
            .card.hover {
                transform: translate3d(11%,0,0);
            }
          }
        &.hover-middle {
            .card.prev {
                transform: translate3d(-10%,0,0);
            }
            .card.next {
                transform: translate3d(10%,0,0);
            }
            .card.hover {
                transform: translate3d(0,0,0);
            }
        }
        &.hover-last {
            .card {
                transform: translate3d(-20%,0,0);
            }
            .card.hover {
                transform: translate3d(-11%,0,0);
            }
        }
    }

    // @media only screen and (min-width: $breakpoint3) {
    //     .row {
    //         margin-bottom: 40px;
    //     }
    // }
</style>



// WEBPACK FOOTER //
// src/components/cards/CardsRow.vue